import {
  add,
  getHours,
  getMinutes,
  startOfToday,
  startOfYesterday,
} from "date-fns";

export function getStationCode() {
  let params = new URLSearchParams(window.location.search);
  return params.get("stationCode");
}

export function getStartTime() {
  const current = {
    hours: getHours(new Date()),
    minutes: getMinutes(new Date()),
  };
  const absolute = { hours: 19, minutes: 30 };
  if (
    current.hours > absolute.hours ||
    (current.hours === absolute.hours && current.minutes >= absolute.minutes)
  ) {
    return add(startOfToday(), absolute);
  }
  return add(startOfYesterday(), absolute);
}

export function getCurrentTime() {
  return new Date();
}



// WEBPACK FOOTER //
// ./src/components/network/NetworkUtil.js